import React, { useMemo } from 'react'; // ✅ เพิ่ม useMemo
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import dayjs from 'dayjs';
import _ from 'lodash';
import { styled } from '@mui/material/styles';
import { addCommas } from '../../utils/functions/commas';
import { CircularProgress } from '@mui/material';
import utc from 'dayjs/plugin/utc';
import SortableTableLabel from '../Table/SortableTableLabel';

dayjs.extend(utc);

const formatStatementDateTime = (value) =>
  value ? dayjs.utc(value).add(7, 'hour').format('YYYY-MM-DD HH:mm:ss.SSS') : '-';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#fff', // หรือ theme.palette.action.hover ถ้าต้องการ
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },

  // [ปรับปรุง] ย้าย :hover มาไว้ที่นี่
  '&:hover': {
   
    boxShadow: '0 6px 16px rgba(0,0,0,0.12)',
    position: 'relative',
    zIndex: 10,
    cursor: 'pointer', // เพิ่ม cursor เพื่อให้รู้ว่า hover ได้
  },


  transition: 'transform 0.15s ',
}));
const StickyTableCell = styled(TableCell)(({ theme }) => ({
  position: 'sticky',
  left: 0,
  backgroundColor: theme.palette.background.paper,
  zIndex: theme.zIndex.appBar, // สำหรับ header ให้สูงกว่า body
}));
function TableLogStatementOnline({
  page,
  total,
  hasMore,
  totalIsExact,
  rowsPerPage,
  setRowsPerPage,
  setPage,
  statementLogValue,
  isFetching,
  t, // ✅ เราจะใช้ t ตัวนี้
  sortBy,
  sortOrder,
  setSortBy,
  setSortOrder,
  // saveQuery,
  // callApiGetStatementOnlineLogs,
}) {
  // ✅ ย้าย columns array เข้ามาข้างใน และใช้ useMemo
  const columns = useMemo(
  () => [
    { id: 'statement_ref', label: t('app.statementRef'), minWidth: 90 }, 
    { id: 'bookbank', label: t('app.bookbankNo'), minWidth: 100 },       // ลดจาก 200 เหลือ 100 เนื่องจากเลขบัญชีมักจะมีความยาวคงที่
    { id: 'transaction_date', label: t('app.dateTime'), minWidth: 110 }, 
    { id: 'amount', label: t('app.actualReceived'), minWidth: 90 },       // ลดลงเล็กน้อยสำหรับช่องตัวเลข
    { id: 'debit_amount', label: t('app.actualPaid'), minWidth: 90 }, 
    { id: 'spend_amount', label: t('app.amountUsed'), minWidth: 90 },     // เปลี่ยนจาก maxWidth เป็น minWidth เพื่อความสม่ำเสมอ
    { id: 'balance', label: t('app.balance'), minWidth: 90 }, 
    { id: 'status', label: t('app.status'), minWidth: 80 },               // ลดลงเหลือ 80 เหมาะสำหรับ Chip หรือข้อความสถานะสั้นๆ
    { id: 'detail_status', label: t('app.detailStatus'), minWidth: 130 }, // ลดจาก 200 
    { id: 'remark', label: t('app.remark'), minWidth: 130 },              // ลดจาก 200 
    { id: 'description', label: t('app.description'), minWidth: 130 },    // ลดจาก 200 
    { id: 'channel', label: t('app.channel'), minWidth: 80 },             // ช่องทางรับชำระมักจะสั้น
    { id: 'customer_code', label: t('navbar.custNo'), minWidth: 90 }, 
    { id: 'customer_name', label: t('navbar.custName'), minWidth: 140 },  // ลดจาก 200 
    { id: 'invoice_no', label: t('app.invoiceNo'), minWidth: 110 },       // ลดจาก 150
    { id: 'bs_no', label: t('app.bsNo'), minWidth: 80 }, 
    { id: 'RC03', label: t('app.rc03'), minWidth: 80 }, 
    { id: 'check_no', label: t('app.chqNo'), minWidth: 80 }, 
    { id: 'edit_by', label: t('app.updateBy'), minWidth: 100 },           // ลดจาก 200 ชื่อผู้แก้ไขย่อลงได้
  ],
  [t],
);

  // const onChangePageTable = (newPage) => {
  //   callApiGetStatementOnlineLogs({
  //     ...saveQuery,
  //     page: newPage + 1,
  //     size: rowsPerPage,
  //   });
  // };
  // const onChangeRowsPerPageTable = (newRows) => {
  //   callApiGetStatementOnlineLogs({
  //     ...saveQuery,
  //     page: 0,
  //     size: newRows,
  //   });
  // };
  // console.log('statementLogValue', statementLogValue);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleRequestSort = (property) => {
    setSortOrder(
      sortBy === property && sortOrder === 'asc' ? 'desc' : 'asc',
    );
    setSortBy(property);
    setPage(0);
  };
  return (
    <div>
      <div className="flex-wrap mt-4  border border-slate-200 ">
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
       <TableContainer sx={{ overflowX: 'auto', overflowY: 'visible' }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => {
                    // const newValue = [column.id];

                    if (column.id === 'statement_ref') {
                      return (
                        <StickyTableCell
                          sx={{
                            backgroundColor: 'primary.main',
                            color: '#fff',
                            minWidth: 200,
                            zIndex: 1200,
                          }}
                        >
                          <SortableTableLabel
                            column={column}
                            sortBy={sortBy}
                            sortOrder={sortOrder}
                            onSort={handleRequestSort}
                            color="white"
                          />
                        </StickyTableCell>
                      );
                    }

                    return (
                      <StyledTableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        <div className="whitespace-nowrap">
                          <SortableTableLabel
                            column={column}
                            sortBy={sortBy}
                            sortOrder={sortOrder}
                            onSort={handleRequestSort}
                            color="white"
                          />
                        </div>
                      </StyledTableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
              {/* <TableBody></TableBody> */} {/* ❌ ลบ <TableBody> ที่ซ้ำและว่างเปล่าออก */}
              <TableBody>
                {isFetching ? (
                  <TableRow>
                    <TableCell> </TableCell>
                    <TableCell> </TableCell>
                    <TableCell> </TableCell>
                    <TableCell> </TableCell>
                    <TableCell> </TableCell>
                    <TableCell align="center">
                      <CircularProgress size={24} />
                    </TableCell>
                    <TableCell> </TableCell>
                  </TableRow>
                ) : statementLogValue.length > 0 ? (
                  _.map(statementLogValue, (item, index) => (
                    <StyledTableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={index}
                    >
                      {columns.map((column) => {
                        const value = item[column.id];

                        if (column.id === 'statement_ref') {
                          return (
                            <StickyTableCell
                              sx={{
                                color: 'primary.light',
                                fontWeight: 'bold',
                              }}
                              key={column.id}
                              align={column.align}
                            >
                              {value}
                            </StickyTableCell>
                          );
                        }

                        if (
                          _.includes(
                            ['transaction_date', 'effective_date'],
                            column.id,
                          )
                        ) {
                          return (
                            <TableCell key={column.id} align="center">
                              {formatStatementDateTime(value)}
                            </TableCell>
                          );
                        }

                        if (
                          _.includes(
                            [
                              'amount',
                              'debit_amount',
                              'spend_amount',
                              'balance',
                              'balance_transaction',
                            ],
                            column.id,
                          )
                        ) {
                          return (
                            <TableCell key={column.id} align="center">
                              {addCommas(value)}
                            </TableCell>
                          );
                        }

                        return (
                          <TableCell
                            key={column.id}
                            align={column.align || 'center'}
                          >
                            {value}
                          </TableCell>
                        );
                      })}
                    </StyledTableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      {t('app.noDataAvailable')} {/* ✅ แก้ไข */}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[5, 25, 100]}
            component="div"
            count={total}
            rowsPerPage={rowsPerPage}
            page={page}
            labelDisplayedRows={({ from, to, count }) =>
              hasMore && !totalIsExact
                ? `${from}–${to} of more than ${addCommas(to, 0)}`
                : `${from}–${to} of ${addCommas(count, 0)}`
            }
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
    </div>
  );
}

export default TableLogStatementOnline;
